import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { TrueLarkConfigurations } from '@frontend/truelark';
import { ConfigCard } from '../../components/config-card/config-card';
import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { useAuth } from '../../providers/auth.provider';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  const { user } = useAuth();

  return (
    <Page
      title='Truelark Configurations'
      breadcrumbs={[{ label: 'Global Settings' }, { label: 'Truelark Configurations' }]}
    >
      <Container>
        {user && (
          <TrueLarkConfigurations user={{ userID: user.userID, username: user.username }} configCard={ConfigCard} />
        )}
      </Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/global-settings/truelark-configurations',
  component: RouteComponent,
  type: 'auth',
  acls: [Permission.TRUELARK_WAM_WRITE],
});
